<template>
</template>

<script setup>
if (useRoute().params.page) {
	useSeoMeta({
		robots: "noindex",
	});
}

useHead({
	link: [
		{
			rel: "canonical",
			href: "https://www.minecraftiplist.com/",
		},
	],
});

definePageMeta({
	layout: "serverlist",
})
</script>